module.exports = __webpack_public_path__ + "static/img/riordain.d317c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/riordain.png
// module id = PA8m
// module chunks = 0